import { Link } from 'react-router-dom';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { TextHeadline } from '@cbhq/cds-web/typography/TextHeadline';

interface BackButtonToProps {
  to: string;
  label?: string;
}

/** Only used in Admin Cluster Portal */
export function BackButtonTo({ to, label = 'Back' }: BackButtonToProps) {
  return (
    <Link to={to} color="foreground">
      <HStack alignItems="center">
        <Icon name="backArrow" size="s" color="currentColor" />
        <TextHeadline as="p" spacingStart={1}>
          {label}
        </TextHeadline>
      </HStack>
    </Link>
  );
}
